export default "__VITE_ASSET__CaMbPgI5__"